import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=b512d7d8&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=b512d7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b512d7d8",
  null
  
)

export default component.exports